import { styled } from '@mui/system'

const Root = styled('div')`
	background-color: ${({ theme }) => theme.palette.grey.main};
	color: ${({ theme }) => theme.palette.common.white};
	padding: ${({ theme }) => theme.spacing(1.25)};
	a {
		color: currentColor;
		text-decoration: none;
	}
`

export { Root }
